
export const sFechaPublicacion = '2026-10-20T15:29:47.8335041-06:00';
export const sVersion = 'vf1.1.610201529';
            